<template>
	<Popup
		v-model="selfDisplay"
		title="治疗记录"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<!-- 表格 -->
			<div class="base_table">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="mid"
						label="机器ID"
					>
					</el-table-column>
					<el-table-column
						prop="origin"
						label="来源"
					>
					</el-table-column>
					<el-table-column
						prop="oname"
						label="机构名称"
					>
					</el-table-column>
					<el-table-column
						prop="uaccount"
						label="用户账户"
					>
					</el-table-column>
					<el-table-column
						prop="params"
						label="运行参数(json)"
					>
					</el-table-column>
					<el-table-column
						prop="finishLabel"
						label="是否完成"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="page"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end-->
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../api/index.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			id: {
				type: Number,
				default: -1
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				page: 1,
				total: 0,
				tableData: []
			}
		},
		methods: {
			// 切换页码
			handlePageChange(page) {
				if (this.page != page) {
					this.page = page;
					this.getData();
				}
			},
			// 获取数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.page,
					pageSize: 10,
					id: that.id
				};
				Api.getTreatmentRecordByIF(requestData).then((res) => {
					if (res.data.success) {
						let list = [];
						that.loading = false;
						res.data.data.records.forEach(v => {
							list.push({
								mid: v.machineId,
								origin: v.userType == 1 ? '门店' : '用户',
								oname: v.enterpriseName,
								uaccount: v.code,
								params: v.runParam,
								finishLabel: v.count == 1 ? '是' : '否',
								time: v.createTs
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.getData();
				} else {
					this.loading = false;
					this.page = 1;
					this.total = 0;
					this.tableData = [];
				}
			}
		}
	}
</script>

<style>
</style>
